import React, { useEffect, useState } from 'react';
import {
  Platform,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
  useWindowDimensions,
  View,
  ScrollView,
} from 'react-native';
import { applyTransparency } from '../../constants/colors';
import { PopupV2 } from './PopupV2';
import ButtonGeneral from './ButtonGeneral';
import {
  GAME_OPERATION_TYPE,
  GAME_TYPE_ARRANGEMENT,
  GAME_TYPES_CONFIG,
  GAME_TYPES_TYPE,
} from '../../constants/constants';
import Check from 'react-native-vector-icons/FontAwesome';

type CheckboxProps = {
  label: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
  textStyle?: TextStyle;
};

const Checkbox = ({ label, value, onChange, textStyle }: CheckboxProps) => {
  return (
    <TouchableOpacity style={styles.checkboxContainer} onPress={() => onChange(!value)}>
      <View style={[styles.checkbox, value && { borderColor: '#E87030' }]}>
        {value === true && <Check name="check" size={16} color="#E87030" />}
      </View>
      <Text style={[styles.label, textStyle]}>{label}</Text>
    </TouchableOpacity>
  );
};

interface IPopupProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  onSavePress: (data: GAME_TYPES_TYPE[] | null) => void;
  games?: GAME_TYPES_TYPE[] | null;
}
const BoardSelectPopUp = ({ visible, setVisible, onSavePress, games = null }: IPopupProps) => {
  const { width } = useWindowDimensions();
  const isMobileWeb = Platform.OS === 'web' && width <= 768;

  const isMobile = isMobileWeb || Platform.OS !== 'web';
  const flexDirection = isMobile ? 'column' : 'row';

  const [selectedGames, setSelectedGames] = useState<GAME_TYPES_TYPE[] | null>(games);

  console.log(games, 'games prop');
  console.log(Array.isArray(selectedGames) && selectedGames.length === 0, 'all boards selected');
  console.log(selectedGames, 'selectedGames state');

  useEffect(() => {
    setSelectedGames(games || null);
  }, [games, visible]);

  const GameListContent = (
    <>
      <View style={[{ flexDirection: 'column', alignItems: 'flex-start' }]}>
        <View style={[styles.operationsContainer]}>
          <Checkbox
            label={'Make All Boards Available'}
            value={Array.isArray(selectedGames) && selectedGames.length === 0}
            onChange={(checked: boolean) => {
              setSelectedGames(checked ? [] : null);
            }}
            textStyle={{ color: '#E87030' }}
          />
        </View>

        <View style={[styles.operationsContainer]}>
          <Text style={[styles.operationTitle]}>Addition</Text>
          {GAME_TYPE_ARRANGEMENT.filter(
            type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.ADDITION,
          ).map(type => (
            <Checkbox
              key={type}
              label={GAME_TYPES_CONFIG[type].name}
              value={selectedGames !== null && selectedGames.includes(type)}
              onChange={(checked: boolean) => {
                setSelectedGames(prev => {
                  if (prev === null) {
                    return [type];
                  }
                  return checked ? [...prev, type] : prev.filter(t => t !== type);
                });
              }}
            />
          ))}
        </View>
        <View style={[styles.operationsContainer]}>
          <Text style={[styles.operationTitle]}>Subtraction</Text>
          {GAME_TYPE_ARRANGEMENT.filter(
            type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.SUBTRACTION,
          ).map(type => (
            <Checkbox
              key={type}
              label={GAME_TYPES_CONFIG[type].name}
              value={selectedGames !== null && selectedGames.includes(type)}
              onChange={(checked: boolean) => {
                setSelectedGames(prev => {
                  if (prev === null) {
                    return [type];
                  }
                  return checked ? [...prev, type] : prev.filter(t => t !== type);
                });
              }}
            />
          ))}
        </View>
        <View style={[styles.operationsContainer]}>
          <Text style={[styles.operationTitle]}>Division</Text>
          {GAME_TYPE_ARRANGEMENT.filter(
            type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.DIVISION,
          ).map(type => (
            <Checkbox
              key={type}
              label={GAME_TYPES_CONFIG[type].name}
              value={selectedGames !== null && selectedGames.includes(type)}
              onChange={(checked: boolean) => {
                setSelectedGames(prev => {
                  if (prev === null) {
                    return [type];
                  }
                  return checked ? [...prev, type] : prev.filter(t => t !== type);
                });
              }}
            />
          ))}
        </View>
      </View>
      <View style={[{ flexDirection: 'column', alignItems: 'flex-start' }]}>
        <View style={[styles.operationsContainer]}>
          <Text style={[styles.operationTitle]}>Multiplication</Text>
          {GAME_TYPE_ARRANGEMENT.filter(
            type => GAME_TYPES_CONFIG[type].operation === GAME_OPERATION_TYPE.MULTIPLICATION,
          ).map(type => (
            <Checkbox
              key={type}
              label={GAME_TYPES_CONFIG[type].name}
              value={selectedGames !== null && selectedGames.includes(type)}
              onChange={(checked: boolean) => {
                setSelectedGames(prev => {
                  if (prev === null) {
                    return [type];
                  }
                  return checked ? [...prev, type] : prev.filter(t => t !== type);
                });
              }}
            />
          ))}
        </View>
      </View>
    </>
  );

  return (
    <PopupV2
      height={isMobile ? 570 : 'auto'}
      title="Boards"
      visible={visible}
      setVisible={setVisible}
      closeOnBackdropPress={true}
      containerStyle={{
        backgroundColor: '#FCEABB',
        borderColor: '#FFCF53',
        width: isMobile ? 348 : 700,
        maxWidth: 1000,
        padding: 0,
      }}
      headerTextStyle={{ fontSize: isMobile ? 18 : 24 }}
      hideCloseButton={true}
    >
      <View style={styles.container}>
        {flexDirection === 'column' ? (
          <ScrollView
            style={{ maxHeight: 500, marginTop: 15 }}
            contentContainerStyle={[
              styles.gamesContainer,
              { flexDirection, alignItems: 'flex-start' },
            ]}
          >
            {GameListContent}
          </ScrollView>
        ) : (
          <View style={[styles.gamesContainer, { flexDirection, alignItems: 'flex-start' }]}>
            {GameListContent}
          </View>
        )}

        <View style={[styles.buttonContainer, { height: isMobile ? 80 : 102 }]}>
          <View style={{ marginRight: isMobile ? 8 : 12 }}>
            <ButtonGeneral
              onPress={() => {
                setVisible(false);
              }}
              title={'Cancel'}
              height={isMobile ? 48 : 58}
              width={isMobile ? 151 : 201}
              fontSize={isMobile ? 14 : 16}
              fontStyle={{ color: '#000000' }}
              colors={['#FEDD88', '#FEDD88']}
              nameContainerStyle={{
                borderColor: '#ffffff',
                borderWidth: 2,
                marginRight: isMobile ? 10 : 0,
              }}
            />
          </View>
          <ButtonGeneral
            onPress={() => onSavePress(selectedGames)}
            title={`Save${isMobile ? '' : ' changes'}`}
            height={isMobile ? 48 : 58}
            width={isMobile ? 151 : 201}
            fontSize={isMobile ? 14 : 16}
            fontStyle={{ color: '#000000' }}
            colors={['#FFCF53', '#FF9900']}
          />
        </View>
      </View>
    </PopupV2>
  );
};

export { BoardSelectPopUp };

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Secular One',
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
    color: '#121212',
    fontSize: 18,
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 20,
  },
  buttonTextStyle: {
    fontFamily: 'Secular One',
    color: '#ffffff',
    fontSize: 20,
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 2,
  },
  label: {
    fontFamily: 'Secular One',
    fontSize: 19,
    fontWeight: '400',
    color: '#121212',
  },
  buttonContainer: {
    justifyContent: 'center',
    backgroundColor: '#FEDD88',
    alignItems: 'center',
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    flexDirection: 'row',
    width: '100%',
    marginTop: 0,
  },
  gamesContainer: {
    flexDirection: 'row',
    width: '100%',
    padding: 20,
    gap: 10,
    justifyContent: 'space-around',
  },
  operationsContainer: {
    marginTop: 24,
    position: 'relative',
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 2,
    borderColor: '#1D1B2059',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  checked: {
    backgroundColor: '#f90',
  },
  operationTitle: {
    fontFamily: 'Secular One',
    fontSize: 14,
    fontWeight: '600',
    color: '#121212',
    marginBottom: 12,
  },
});
